<header>
  <mat-icon svgIcon="handshake-icon"/>
  <h2>Connect with {{ partnerValue.name }}</h2>
  <fa-icon (click)="close()" icon="times"/>
</header>

<section>
  <div class="disclosure-text" [innerHTML]="partnerValue.disclosureText"></div>

  <div class="form-divider"></div>

  <form [formGroup]="partnerFormGroup">
    @for (cell of formTemplate(); track cell) {
      @if (cell.fields) {
        <div class="input-group">
          @for (field of cell.fields; track field.key) {
            <cpd-premium-partner-input
              [label]="field.label"
              [id]="field.key"
              [options]="field?.options"
              [type]="field.type"
              [placeholder]="field.placeholder"
              [formControlName]="field.key"/>
          }
        </div>
      } @else {
        <cpd-premium-partner-input
          [label]="cell.label"
          [id]="cell.key"
          [options]="cell?.options"
          [placeholder]="cell.placeholder"
          [type]="cell.type"
          [formControlName]="cell.key"/>
      }
    }
  </form>

  @if (isUnder18()) {
    <p class="under-18" role="alert">{{ under18Message }}</p>
  }

  <div class="extra-info">
    <mat-icon svgIcon="shield-halve"/>
    <p>
      Your data will be shared only with Kollegio.ai for the purpose of connecting you with academic opportunities. You
      can
      revoke this at any time from your Connect settings.</p>
  </div>
</section>

<div class="button-group">
  <button class="outlined" type="button" [class.disabled]="isDisableSkip" (click)="onSkip()">
    Skip {{ partnerValue.slug }}
  </button>
  <button class="flat" [class.disabled]="!isPartnerFormValid() || isUnder18()" type="button" (click)="onShareAndConnect()">Share and
    Connect
  </button>
</div>
